module.exports = __webpack_public_path__ + "images/14-01_b7d6857f.jpg";